// Corps & Sens — brand constants
export const BRAND = {
  name: "Corps & Sens",
  phoneDisplay: "07 56 96 82 53",
  phoneHref: "tel:+33756968253",
  address: "12 rue des Lauriers, 75006 Paris",
  hoursShort: "Lun — Sam · 10h — 20h",
  instagram: "https://www.instagram.com/corpsetsens/",
  email: "corpsetsens83@gmail.com",
};
